export var LobbyStatus;
(function (LobbyStatus) {
    LobbyStatus["WAITING"] = "waiting";
    LobbyStatus["STARTING"] = "starting";
    LobbyStatus["IN_PROGRESS"] = "in_progress";
    LobbyStatus["FINISHED"] = "finished";
})(LobbyStatus || (LobbyStatus = {}));
//# sourceMappingURL=lobby.js.map